module.exports = __webpack_public_path__ + "img/denmark-cardiovascular-diseases-male.5d7f4f72.png";